import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />
    <div className="my-6">
      <section className="mb-6">
        <h2 className="text-5xl tracking-tight leading-none uppercase">
          Contact
        </h2>
      </section>
      <div className="flex flex-col">
        <p className="mb-2">
          Need to reach me? Want some advice? Just need a quick chat?
        </p>
        <p className="mb-6">
          Feel free to DM me at{" "}
          <a
            href="https://twitter.com/alvincrespo"
            target="_blank"
            rel="noopener noreferrer"
          >
            @alvincrespo
          </a>{" "}
          or fill out the form below.
        </p>
        <form
          name="contact"
          method="POST"
          action="/contact-success"
          className="w-full max-w-screen-sm"
          data-netlify="true"
        >
          <input type="hidden" name="form-name" value="contact" />
          <div className="flex flex-col mb-4">
            <label className="block" htmlFor="name">
              name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="clark kent"
              required
              className="block border p-2"
            />
          </div>
          <div className="flex flex-col mb-4">
            <label className="block" htmlFor="email">
              email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="clark.kent@dailyplanet.org"
              required
              className="block border p-2"
            />
          </div>
          <div className="flex flex-col mb-4">
            <label className="block" htmlFor="topic">
              topic
            </label>
            <select
              className="block appearance-none p-2 border"
              id="topic"
              name="topic"
            >
              <optgroup label="technical">
                <option value="other">technical architecture</option>
                <option value="other">design patterns</option>
                <option value="other">best practices</option>
                <option value="other">performance optimization</option>
                <option value="other">accessibility</option>
              </optgroup>
              <optgroup label="leadership">
                <option value="other">hiring</option>
                <option value="other">personal development</option>
                <option value="other">mentorship</option>
              </optgroup>
              <optgroup label="project management">
                <option value="other">estimating</option>
                <option value="other">
                  ticket writing (epics, stories, bugs, etc...)
                </option>
                <option value="other">defining requirements and scoping</option>
              </optgroup>
              <option value="other">other</option>
            </select>
          </div>
          <div className="flex flex-col mb-4">
            <label className="block" htmlFor="reason">
              reason
            </label>
            <textarea
              id="reason"
              maxLength="280"
              name="reason"
              className="block border p-2"
            ></textarea>
          </div>
          <div className="flex flex-col mb-4">
            <button
              className="bg-deeppink text-black font-bold border border-2 border-deeppink p-1 cursor-pointer hover:text-cyan hover"
              type="submit"
            >
              <span
                className="mx-1 inline-block"
                style={{ transform: "scale(-1, 1)" }}
                role="img"
                aria-label="rocket"
              >
                🚀
              </span>{" "}
              <span className="mx-1">get in touch</span>{" "}
              <span className="mx-1" role="img" aria-label="rocket">
                🚀
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </Layout>
)

export default ContactPage
